<div [title]="isTimeExceeded? timerTextExceeded : timerText">
    <span class="fas fa-info-circle {{isTimeExceeded?'time-exceeded':''}}"  ></span>
</div>